<!--
 * @Author: katty 15032801667@163.com
 * @Date: 2022-12-01 18:09:41
 * @LastEditors: katty 15032801667@163.com
 * @LastEditTime: 2022-12-29 11:05:10
 * @FilePath: \epec-ea\src\modules\projectA\pages\approve\purchaseApprove\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <approve-list :title="title" :type="flag" :key="flag"></approve-list>
  </div>
</template>

<script>
import ApproveList from '../component/approveList';
export default {
  name: 'purchaseApprove',

  components: {
    ApproveList,
  },
  data() {
    return {
      title: '采购计划审批',
      flag: 4,
    };
  },

  mounted() {},

  methods: {},
};
</script>

<style lang="scss" scoped></style>
